"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitySpinnerWidget = exports.ActivitySpinnerSize = void 0;
var tslib_1 = require("tslib");
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../gen-src/Localize");
var Declarative_1 = require("../utils/Declarative");
var ReactHelpers_1 = require("../utils/ReactHelpers");
var ActivitySpinnerSize;
(function (ActivitySpinnerSize) {
    ActivitySpinnerSize[ActivitySpinnerSize["Large"] = 50] = "Large";
    ActivitySpinnerSize[ActivitySpinnerSize["Small"] = 14] = "Small";
})(ActivitySpinnerSize = exports.ActivitySpinnerSize || (exports.ActivitySpinnerSize = {}));
/** An inline activity spinner */
exports.ActivitySpinnerWidget = React.forwardRef(function (props, ref) {
    var alt = props.alt, onDarkBackground = props.onDarkBackground, shouldShowUnderlay = props.shouldShowUnderlay, spinnerSize = props.spinnerSize, testId = props.testId, htmlAttrs = tslib_1.__rest(props, ["alt", "onDarkBackground", "shouldShowUnderlay", "spinnerSize", "testId"]);
    var isTua = ReactHelpers_1.useTuaStatus();
    if (isTua) {
        return React.createElement(TUASpinner, tslib_1.__assign({}, props, { ref: ref }));
    }
    return React.createElement(tableau_ui_1.Spinner, tslib_1.__assign({ alt: alt !== null && alt !== void 0 ? alt : Localize_1.Messages.waitIndicatorLabel(), "data-tb-test-id": Declarative_1.makeTestId(testId, 'Spinner') }, htmlAttrs, { color: onDarkBackground ? 'light' : 'dark', dimension: spinnerSize, presentation: spinnerSize === ActivitySpinnerSize.Large ? 'alert' : 'inline', ref: ref, showUnderlay: shouldShowUnderlay }));
});
exports.ActivitySpinnerWidget.defaultProps = { spinnerSize: ActivitySpinnerSize.Large };
exports.ActivitySpinnerWidget.displayName = 'ActivitySpinnerWidget';
var TUASpinnerStyleName = TypeStyle.style((_a = {
        $debugName: 'tuaSpinner'
    },
    _a['--slds-g-color-neutral-base-50'] = '#747474',
    _a['--slds-g-color-neutral-base-100'] = '#FFFFFF',
    _a['--spinner-dot-color'] = 'var(--slds-g-color-neutral-base-50)',
    _a['--spinner-dimension'] = ActivitySpinnerSize.Large + "px",
    _a.boxSizing = 'border-box',
    _a.cursor = 'wait',
    _a.height = "var(--spinner-dimension)",
    _a.width = "var(--spinner-dimension)",
    _a.$nest = {
        '&.inverse': (_b = {},
            _b['--spinner-dot-color'] = 'var(--slds-g-color-neutral-base-100)',
            _b),
        '&.small': (_c = {},
            _c['--spinner-dimension'] = ActivitySpinnerSize.Small + "px",
            _c['--spinner-extra-transforms'] = 'translate(-11px, -11.5px) scale(0.25)',
            _c),
        '&.underlay': {
            background: 'rgba(255,255,255,.6)',
            borderRadius: '15%',
            padding: "calc(0.15 * var(--spinner-dimension))",
            height: "calc(1.3 * var(--spinner-dimension))",
            width: "calc(1.3 * var(--spinner-dimension))",
        },
    },
    _a));
var makeDotsAnimation = function (distance) { return TypeStyle.keyframes({
    $debugName: "dotAnimation",
    '0%': { transform: "translate(0)" },
    '60%': { transform: "translate(0)", animationTimingFunction: 'cubic-bezier(.55,.085,.68,.53)' },
    '80%': { transform: "translate(" + distance + "px, 0)", animationTimingFunction: 'cubic-bezier(0,1.11,.7,1.43)' },
    '100%': { transform: "translate(0)" },
}); };
var SLDSSpinnerStyleName = TypeStyle.style({
    $debugName: 'sldsSpinner',
    boxSizing: 'border-box',
    display: 'inline-block',
    position: 'relative',
    height: 32,
    width: 32,
    transformOrigin: '50% 50%',
    transform: 'var(--spinner-extra-transforms,) translate(-7px, 9px) rotate(90deg)',
    $nest: {
        '&::before, &::after, &>::before, &>::after': {
            animationDuration: '1s',
            animationIterationCount: 'infinite',
            background: 'var(--spinner-dot-color)',
            borderRadius: '50%',
            content: "\"\"",
            display: 'inline-block',
            height: 8,
            position: 'absolute',
            transform: "translate(0)",
            width: 8,
            top: -4,
        },
        '&::before, &>::before': { animationName: makeDotsAnimation(-8), left: -4 },
        '&::after, &>::after': { animationName: makeDotsAnimation(8), right: -4 },
        '&>:first-child': { transform: 'rotate(60deg)', transformOrigin: '50% 50%' },
        '&>:last-child': { transform: 'rotate(120deg)', transformOrigin: '50% 50%' },
        '&::before': { animationDelay: 'calc(-1s / 12)' },
        '&>:first-child::before': { animationDelay: 'calc(1s / 12)' },
        '&>:last-child::before': { animationDelay: 'calc(3s / 12)' },
        '&::after': { animationDelay: 'calc(5s / 12)' },
        '&>:first-child::after': { animationDelay: 'calc(7s / 12)' },
        '&>:last-child::after': { animationDelay: 'calc(9s / 12)' },
    }
});
/** reproduction of https://www.lightningdesignsystem.com/components/spinners/#About-Spinners */
var TUASpinner = React.forwardRef(function (_a, ref) {
    var alt = _a.alt, onDarkBackground = _a.onDarkBackground, shouldShowUnderlay = _a.shouldShowUnderlay, spinnerSize = _a.spinnerSize, testId = _a.testId, htmlAttrs = tslib_1.__rest(_a, ["alt", "onDarkBackground", "shouldShowUnderlay", "spinnerSize", "testId"]);
    return (React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, 'Spinner'), role: 'status' }, htmlAttrs, { className: TypeStyle.classes(TUASpinnerStyleName, { inverse: onDarkBackground, small: spinnerSize === ActivitySpinnerSize.Small, underlay: shouldShowUnderlay }, htmlAttrs.className), ref: ref }),
        React.createElement("div", { "aria-hidden": tableau_ui_1.useInitiallyHiddenElement() && spinnerSize === ActivitySpinnerSize.Large, "aria-label": alt !== null && alt !== void 0 ? alt : Localize_1.Messages.waitIndicatorLabel(), className: SLDSSpinnerStyleName, role: 'img' },
            React.createElement("div", null),
            React.createElement("div", null))));
});
TUASpinner.displayName = 'TUASpinner';
//# sourceMappingURL=ActivitySpinnerWidget.js.map